/**
 * @generated SignedSource<<29c94c4efbcfd8cff6ad1982c0037f06>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSellerItemTileCarousel_user$data = {
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"SharedRespRelatedItem_user">;
  readonly " $fragmentType": "PdpRespSellerItemTileCarousel_user";
};
export type PdpRespSellerItemTileCarousel_user$key = {
  readonly " $data"?: PdpRespSellerItemTileCarousel_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSellerItemTileCarousel_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSellerItemTileCarousel_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedRespRelatedItem_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "e24aaedcf3a0496c7cf6487a0ac1799d";

export default node;
